/*
 * @Author: your name
 * @Date: 2021-07-25 19:03:17
 * @LastEditTime: 2022-03-05 22:56:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \k-gantt\src\scroll.js
 */

export default class Xscroll {
    constructor(wrapper, options) {
        let that = this;
        let default_options = {
            elementWidth: null, //主体元素的宽度，有这个参数就不需要动态调用wrapper_element的marginLeft
            'overflow-x': !0,
            'overflow-y': !0,
            blockWidthMin: 20 //滑动的最小宽度
        };
        this.options = Object.assign({}, default_options, options);
        that.createBaseEl(wrapper);
        this.calculateScrollBar();
        that.bindEvent();
    }
    createBaseEl(element) {
        let that = this;
        that.$wrapper_element = null;
        that.$element = null;
        if (typeof element === 'string') {
            this.$element = document.querySelector(element);
            this.$wrapper_element =
                this.$element.parentElement || this.$element.parentNode;
        } else {
            if (
                element instanceof HTMLElement ||
                element instanceof SVGElement
            ) {
                this.$element = element;
                this.$wrapper_element =
                    element.parentElement || element.parentNode;
            } else {
                throw new TypeError(
                    'Frappé Gantt only supports usage of a string CSS selector,' +
                        " HTML DOM element or SVG DOM element for the 'element' parameter"
                );
            }
        }
        // get the SVGElement
        if (this.$wrapper_element instanceof HTMLElement) {
        } else {
            throw new TypeError(
                'Frappé Gantt only supports usage of a string CSS selector,' +
                    " HTML DOM element or SVG DOM element for the 'element' parameter"
            );
        }
        this.$wrapper_element.classList.add('Xscroll');
        this.$barY = this.$wrapper_element.querySelector('.Xscroll-y');
        if (that.$barY instanceof HTMLElement) {
            that.$barYBlock =  this.$barY.querySelector('.Xscroll-y-block');
            if (that.$barYBlock instanceof HTMLElement) {
            } else {
                that.$barYBlock = document.createElement('div');
                that.$barYBlock.classList.add('Xscroll-y-block');
                that.$barY.appendChild(that.$barYBlock);
                that.$barYBlock.style.position = 'absolute';
                that.$barYBlock.style.width = '100%';
                that.$barYBlock.style.height = '50px';
                that.$barYBlock.style.background = '#999';
                that.$barYBlock.style.borderRadius = '20px';
                that.$barYBlock.style.top = 0;
            }
        } else {
            this.$barY = document.createElement('div');
            this.$barY.classList.add('Xscroll-y');
            this.$wrapper_element.appendChild(this.$barY);
            that.$barYBlock = document.createElement('div');
            that.$barYBlock.classList.add('Xscroll-y-block');
            that.$barY.appendChild(that.$barYBlock);
            that.$barY.style.position = 'absolute';
            that.$barY.style.width = '8px';
            that.$barY.style.height = 'calc( 100% - 6px )';
            that.$barY.style.background = 'rgb(238 238 238 / 20%)';
            that.$barY.style.right = 0;
            that.$barY.style.top = 0;
            // that.$barY.style.opacity = 0.5;

            that.$barYBlock.style.position = 'absolute';
            that.$barYBlock.style.width = '100%';
            that.$barYBlock.style.height = '50px';
            that.$barYBlock.style.background = '#999';
            that.$barYBlock.style.borderRadius = '20px';
            that.$barYBlock.style.top = 0;
        }

        this.$barX = this.$wrapper_element.querySelector('.Xscroll-x');
        if (that.$barX instanceof HTMLElement) {
            that.$barXBlock = this.$barX.querySelector('.Xscroll-x-block');
            if (that.$barXBlock instanceof HTMLElement) {
            } else {
                that.$barXBlock = document.createElement('div');
                that.$barXBlock.classList.add('Xscroll-x-block');
                that.$barX.appendChild(that.$barXBlock);
                that.$barXBlock.style.position = 'absolute';
                that.$barXBlock.style.height = '100%';
                that.$barXBlock.style.width = '50px';
                that.$barXBlock.style.background = '#B5B5B5';
                that.$barXBlock.style.borderRadius = '20px';
                that.$barXBlock.style.left = 0;
            }
        } else {
            this.$barX = document.createElement('div');
            this.$barX.classList.add('Xscroll-x');
            this.$wrapper_element.appendChild(this.$barX);
            that.$barXBlock = document.createElement('div');
            that.$barXBlock.classList.add('Xscroll-x-block');
            that.$barX.appendChild(that.$barXBlock);
            that.$barX.style.position = 'absolute';
            that.$barX.style.width = 'calc( 100% - 6px )';
            that.$barX.style.height = '8px';
            that.$barX.style.background = 'rgb(238 238 238 / 20%)';
            that.$barX.style.left = 0;
            that.$barX.style.bottom = 0;

            that.$barXBlock.style.position = 'absolute';
            that.$barXBlock.style.height = '100%';
            that.$barXBlock.style.width = '50px';
            that.$barXBlock.style.background = '#B5B5B5';
            that.$barXBlock.style.borderRadius = '20px';
            that.$barXBlock.style.left = 0;
        }
    }

    calculateScrollBar() {
        let that = this;
        that.bili = that.$element.offsetHeight / that.$wrapper_element.offsetHeight; //盒子和内容的比例
        that.$barYBlock.style.height = that.$barY.offsetHeight / that.bili + 'px'; //内容的高
        if (that.$barY.offsetHeight / that.bili < that.options.blockWidthMin) {
            that.$barYBlock.style.height = that.options.blockWidthMin + 'px';
            that.bili = that.$barY.offsetHeight / that.options.blockWidthMin;
        }
        that.zdh = that.$barY.offsetHeight - that.$barYBlock.offsetHeight; //最大的top值
        if (that.zdh < 0) that.zdh = 0;
        if (that.bili > 1) {
            that.bili =
                (that.$element.offsetHeight -
                    that.$wrapper_element.offsetHeight) /
                that.zdh; //根据实际宽度 重新计算比例
        }

        that.spend = 50;

        that.biliX = that.$element.offsetWidth / that.$wrapper_element.offsetWidth; //估算盒子和内容的比例
        if (this.options.elementWidth)
            that.biliX = this.options.elementWidth / that.$wrapper_element.offsetWidth; //估算盒子和内容的比例
        that.$barXBlock.style.width = that.$barX.offsetWidth / that.biliX + 'px'; //计算滑块高度宽度
        if (that.$barX.offsetWidth / that.biliX < that.options.blockWidthMin) {     //不得低于最高宽度
            that.$barXBlock.style.width = that.options.blockWidthMin + 'px';
        }
        that.zdhX = that.$barX.offsetWidth - that.$barXBlock.offsetWidth; //最大的top值
        if (that.zdhX < 0) that.zdhX = 1;
        if (that.biliX > 1) {
            that.biliX =
                (that.$element.offsetWidth -
                    that.$wrapper_element.offsetWidth) /
                that.zdhX; //根据实际宽度 重新计算比例
            if (this.options.elementWidth)
                that.biliX =
                    (this.options.elementWidth -
                        that.$wrapper_element.offsetWidth) /
                    that.zdhX; //根据实际宽度 重新计算比例
        }

        //elem.style.setProperty( 'color', 'green', 'important' );
        if (that.biliX <= 1 || this.options['overflow-x'] == false) {
            that.$barX.style.setProperty('visibility', 'hidden', 'important');
        } else that.$barX.style.visibility = 'initial';

        if (that.bili <= 1 || this.options['overflow-y'] == false) {
            that.$barY.style.setProperty('visibility', 'hidden', 'important');
        } else that.$barY.style.visibility = 'initial';
    }
    reset() {
        let that = this;
        let tops = that.$barYBlock.offsetTop || 0;
        if (tops < 0) {
            tops = 0;
        } else if (tops > that.zdh) {
            tops = that.zdh;
        }
        that.$barYBlock.style.top = tops + 'px';
        that.$element.style.marginTop = -tops * that.bili + 'px';
        //console.log('xScroll reset top:' + (tops * that.bili));
        if (typeof that.options.onChangeY == 'function')
            that.options.onChangeY(tops * that.bili);

        let rights = that.$barXBlock.offsetLeft || 0;
        if (rights < 0) {
            rights = 0;
        } else if (rights > that.zdhX) {
            rights = that.zdhX;
        }
        that.$barXBlock.style.left = rights + 'px';
        if (!that.options.elementWidth)
            that.$element.style.marginLeft = -rights * that.biliX + 'px';
        window.getSelection
            ? window.getSelection().removeAllRanges()
            : document.selection.empty();
        //console.log('xScroll reset left:' + (rights * that.biliX));
        if (typeof that.options.onChangeX == 'function')
            that.options.onChangeX(rights * that.biliX);
    }
    mouseWheel(obj, upfun, downfun) {
        if (obj.addEventListener) {
            obj.addEventListener('mousewheel', fn);
            obj.addEventListener('DOMMouseScroll', fn);
        } else {
            obj.attachEvent('onmousewheel', fn);
        }

        function fn(e) {
            let ev = e || window.event;
            //鼠标滚轮滚动的方向
            let val = ev.detail || ev.wheelDelta;
            //console.log(...['ev.detail',ev.detail,'ev.wheelDelta',ev.wheelDelta]);
            if (ev.detail) {
                if (ev.detail < 0) upfun();
                else downfun();
            } else if (ev.wheelDelta) {
                if (ev.wheelDelta > 0) upfun();
                else downfun();
            } else if (val == -3 || val == 120) {
                upfun(); //向上滚
            } else if (val == 3 || val == -120) {
                downfun(); //向下滚
            }
            if (ev.preventDefault) {
                ev.preventDefault();
            } else {
                ev.returnValue = false;
            }
        }
    }
    setScrollmargin(arg) {
        let that = this;
        //根据marginTop的位置调整 black的位置
        if (arg.hasOwnProperty('marginTop')) {
            let tops = Math.abs(arg.marginTop) / that.bili;
            that.$barYBlock.style.top = tops + 'px';
        }
        if (arg.hasOwnProperty('marginLeft')) {
            let rights = Math.abs(arg.marginLeft) / that.biliX;
            that.$barXBlock.style.left = rights + 'px';
        }
    }
    // 是否到结
    isScrollXEnd(x) {
        let rights = Math.abs(x) / this.biliX;
        if (rights > this.zdhX) {
            return 0 - this.zdhX * this.biliX;
        }
        return x;
    }
    isScrollYEnd(y) {
        let tops = Math.abs(y) / this.bili;
        if (tops > this.zdh) {
            return 0 - this.zdh * this.bili;
        }
        return y;
    }
    setScroll(arg) {
        let that = this;
        //根据marginTop的位置调整 black的位置
        if (arg.hasOwnProperty('y')) {
            let tops = Math.abs(arg.y) / that.bili;
            that.$element.style.marginTop = -tops + 'px';
            that.$barYBlock.style.top = arg.y + 'px';
            that.options.onChangeY(tops);
        }
        if (arg.hasOwnProperty('x')) {
            let rights = Math.abs(arg.x) / that.biliX;
            if (!that.options.elementWidth)
                that.$element.style.marginLeft = -rights + 'px';
            that.$barXBlock.style.left = arg.x + 'px';
            that.options.onChangeX(rights);
        }
    }

    getScroll() {
        return {
            blockX: this.$barXBlock.offsetLeft,
            blockY: this.$barYBlock.offsetTop,
            scrollX: this.$barXBlock.offsetLeft * this.biliX,
            scrollY: this.$barXBlock.offsetTop * this.bili
        };
    }

    bindEvent() {
        let that = this;
        that.$barYBlock.onmousedown = function(e) {
            let ev = e || window.event;
            let y = ev.clientY - that.$barYBlock.offsetTop; //鼠标点击时滚动条的位置
            let dydown = true;
            document.onmousemove = function(e) {
                if (!dydown) return;
                let ev = e || window.event;
                let tops = ev.clientY - y; //滚动时top值
                if (tops < 0) {
                    tops = 0;
                } else if (tops > that.zdh) {
                    tops = that.zdh;
                }
                that.$barYBlock.style.top = tops + 'px';
                that.$element.style.marginTop = -tops * that.bili + 'px';
                window.getSelection
                    ? window.getSelection().removeAllRanges()
                    : document.selection.empty();
                //console.log('xScroll top:' + (tops * that.bili));
                if (typeof that.options.onChangeY == 'function')
                    that.options.onChangeY(tops * that.bili);
            };
            document.onmouseup = function() {
                document.onmousemove = null;
                document.onmouseup = null;
                dydown = false;
            };
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        that.$barXBlock.onmousedown = function(e) {
            let ev = e || window.event;
            let x = ev.clientX - that.$barXBlock.offsetLeft; //鼠标点击时滚动条的位置
            let dxdown = true;
            document.onmousemove = function(e) {
                if (!dxdown) return;
                let ev = e || window.event;
                let rights = ev.clientX - x; //滚动时top值
                if (rights < 0) {
                    rights = 0;
                } else if (rights > that.zdhX) {
                    rights = that.zdhX;
                }
                that.$barXBlock.style.left = rights + 'px';
                if (!that.options.elementWidth)
                    that.$element.style.marginLeft = -rights * that.biliX + 'px';
                window.getSelection
                    ? window.getSelection().removeAllRanges()
                    : document.selection.empty();
                //console.log('xScroll left:' + (rights * that.biliX));
                if (typeof that.options.onChangeX == 'function')
                    that.options.onChangeX(rights * that.biliX);
            }
            document.onmouseup = function() {
                document.onmousemove = null;
                document.onmouseup = null;
                dxdown = false;
            };
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        this.mouseWheel(this.$wrapper_element, function () {
            if (that.$barYBlock.offsetTop <= 0) {
                that.$barYBlock.style.top = 0 + 'px';
                that.$element.style.marginTop = 0 + 'px';
        
            } else {
                
                let top = that.$barYBlock.offsetTop - that.spend / that.bili;
                let marginTop = that.$element.offsetTop + that.spend;
                if(top <= 0)
                {
                    top = 0;
                    marginTop = 0;
                }
                that.$element.style.marginTop = marginTop + "px";
                that.$barYBlock.style.top = top + 'px';
            }
            //console.log('xScroll top:' + parseFloat(that.$element.style.marginTop));
            if (typeof that.options.onChangeY == 'function')
                    that.options.onChangeY(
                        0 - parseFloat(that.$element.style.marginTop)
                    );
        }, function () {
            if (that.$barYBlock.offsetTop >= that.zdh) {
                that.$barYBlock.style.top = that.zdh + 'px';
                that.$element.style.marginTop = -that.zdh * that.bili + 'px';
            } else {
                    let top =
                        that.$barYBlock.offsetTop + that.spend / that.bili;
                if(top >= that.zdh) {
                    that.$barYBlock.style.top = that.zdh + 'px';
                    that.$element.style.marginTop = -that.zdh * that.bili + 'px';
                } else {
                    that.$element.style.marginTop = that.$element.offsetTop - that.spend + "px";
                    that.$barYBlock.style.top = top + 'px';
                }
            }
            //console.log('xScroll top:' + parseFloat(that.$element.style.marginTop));
            if (typeof that.options.onChangeY == 'function')
                that.options.onChangeY(
                    0 - parseFloat(that.$element.style.marginTop)
                );
        })
    }

    refresh(opt) {
        if (opt) this.options = Object.assign({}, this.options, opt);
        this.calculateScrollBar();
        this.reset();
    }
}
